import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullScreenLoader() {
  return (
    <div
      data-testid="auth-loading"
      className="min-h-screen flex items-center justify-center bg-slate-50"
    >
      <Loader2 className="h-8 w-8 animate-spin text-[#0f2847]" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) return <FullScreenLoader />;
  if (user === null) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user.must_change_password && location.pathname !== "/change-initial-password") {
    return <Navigate to="/change-initial-password" replace />;
  }
  // Super Admin is scoped to branch management only; keep them out of branch-scoped
  // operational modules (which require a branch_id they do not have).
  if (user.role === "super_admin" && location.pathname !== "/cabang") {
    return <Navigate to="/cabang" replace />;
  }
  if (user.role !== "super_admin" && location.pathname === "/cabang") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export function FirstLoginRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <FullScreenLoader />;
  if (user === null) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/dashboard" replace />;
  return children;
}
